import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import Button from 'components/forms/button/Button'

const breakpoints = [640, 990]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const sidePanelMQ = css(mq({
  display: ["none", "none", "flex"]
}))

export const SidePanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-shrink: 0;
  width: 320px;
  gap: 24px;
  padding: 48px 36px;
  background-color: var(--color-primary-400);
  ${sidePanelMQ}
`

export const SidePanelBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 320px;
  height: 380px;
  background-image: url(//cdn-platform.scope-dev.ws/website/modals/releases-head@2x.png);
  background-size: 320px 380px;

  &:before {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 180px;
    background: linear-gradient(0deg, #32AFE2 0%, rgba(50, 175, 226, 0.00) 100%);
  }
`

export const SideSlogan = styled.div`
  color: var(--color-white);
  font: var(--text-540);
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const innerContentMQ = css(mq({
  padding: ["0 32px 44px", "0 44px 44px"],
  width: ["auto", "auto", 560],
}))

export const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow: auto;
  ${innerContentMQ}
`

const headerMQ = css(mq({
  padding: ["32px 32px 0", "44px 44px 0", "44px 44px 0"],
}))

export const Header = styled.div`
  ${headerMQ}
`
export const Heading = styled.h3`
  font: var(--accent-770);
`

const closeButtonMQ = css(mq({
  top: [8, 8, 20],
  right: [8, 8, 20],
}))

export const CloseButton = styled(Button)`
  position: absolute;
  ${closeButtonMQ}
`

export const Banner = styled.div`
  font: var(--text-340);
  padding: 20px 24px;
  display: flex;
  gap: 16px;
  align-items: center;
  background: var(--color-grayscale-37);
  border-radius: 16px;
`

export const IconBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  border-radius: 10px;
  width: 32px;
  height: 32px;
  background: var(--color-blue-500);
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  gap: 32px;
`

const formContentMQ = css(mq({
  gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr"],
}))

export const FormContent = styled.div`
  display: grid;
  gap: 24px;
  ${formContentMQ}
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const InputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > label {
    font: var(--text-350);
  }
`

const footerMQ = css(mq({
  flexDirection: ["column-reverse", "row"],
  alignItems: ["stretch", "center"],
}))

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: end;
  ${footerMQ}
`
